export default "__VITE_ASSET__JrjjP2lv__"